module.exports = __webpack_public_path__ + "static/img/pic22.6430f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic22.png
// module id = A6GN
// module chunks = 0